import { AuthContextType } from '@auth/AuthProvider';
import NetworkController, { HTTPMethod, HTTPRequest, HTTPResponse } from '@data/controller/NetworkController';
import { Campus } from '@data/ChurchDataProvider';

export interface CampusAttributes {
  name: string;
  address?: {
    street: string;
    state: string;
    zip: string;
    city: string;
    country: string;
  };
}

export default class CampusController {
  private static baseURL: string = process.env.REACT_APP_SANCTUARY_API_URL || "";

  static async createCampus(
    churchID: string,
    attributes: CampusAttributes,
    auth: AuthContextType
  ): Promise<HTTPResponse<Campus>> {
    return await NetworkController.performRequestAt<Campus>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.POST, `/v1/church/${churchID}/campus`, {
        attributes
      }),
      auth.consumeRefreshToken
    );
  }

  static async updateCampus(
    churchID: string,
    campusID: string,
    attributes: CampusAttributes,
    auth: AuthContextType
  ): Promise<HTTPResponse<Campus>> {
    return await NetworkController.performRequestAt<Campus>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.PATCH, `/v1/church/${churchID}/campus/${campusID}`, {
        attributes
      }),
      auth.consumeRefreshToken
    );
  }

  static async deleteCampus(
    churchID: string,
    campusID: string,
    auth: AuthContextType
  ): Promise<HTTPResponse<void>> {
    return await NetworkController.performRequestAt<void>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.DELETE, `/v1/church/${churchID}/campus/${campusID}`),
      auth.consumeRefreshToken
    );
  }
}
